import { RESET_REQUEST_TIMEOFF } from './constants';
import { CFAuthPostRef } from "auth";
import { locations } from '../../common/redux/action_locations';

function receivedRestartAgentVerificationInfo(data) {
  return {
    type: RESET_REQUEST_TIMEOFF
  };
}

function restartAgentVerificationInfo(agentID) {
  return CFAuthPostRef({
    url: `${process.env.REACT_APP_AP_API_URL}/AgentVerification/Reset/?agentId=${agentID}`,
    originURL: process.env.PUBLIC_URL,
    loaderName: ''
  })
}

export function restartAgentVerificationInfoAction(filters){
  return {
    type: RESET_REQUEST_TIMEOFF,
    data: { locations, filters },
    locations: locations,
    fetchCall: restartAgentVerificationInfo,
    receivedAction: receivedRestartAgentVerificationInfo
  }
}
  
export function reducer(state, { type }) {
  switch (type) {
    case RESET_REQUEST_TIMEOFF:
      return {
        ...state
      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/agent-info-verification/redux/restartVerificationProcess.js